var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E0E7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9995 21.5V23.5M23.9995 27.5H24.0095M17.0713 31.5H30.9277C32.4673 31.5 33.4296 29.8333 32.6598 28.5L25.7316 16.5C24.9618 15.1667 23.0373 15.1667 22.2675 16.5L15.3393 28.5C14.5695 29.8333 15.5317 31.5 17.0713 31.5Z",
    stroke: "#4338CA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueWarningIcon);
export default __webpack_public_path__ + "static/media/blueWarningIcon.d52148b882c141ab467de339bf578829.svg";
export { ForwardRef as ReactComponent };